import React, { useState, useEffect } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button, IconButton, Grid, Box, MenuItem
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import UploadComp from '../../common/components/Upload';

const WEEK_DAYS = [
  "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday", "All"
];

const LOCATION_OPTIONS = [
  "Rachenahalli 1",
  "Rachenahalli 2",
  "Rachenahalli 3",
  "HegdeNagar 1",
  "HegdeNagar 2",
  "Bharatiya City 1",
  "Bharatiya City 2",
  "Bharatiya City 3",
  "Kannur 1",
  "Kannur 2",
  "Kannur 3",
  "WebCity 1",
  "WebCity 2",
  "Kothanur 1",
  "Kothanur 2",
  "Kothanur- Narayanpura 1",
  "Kothanur- Narayanpura 2",
  "Kothanur- Narayanpura 3",
  "Byrathi 1",
  "Hennur Main Road 1",
  "Hennur Cross 1",
  "Ashwath nagar 1"
];

const AddUserDialog = ({ open, onClose, onUserAdded, user}) => {
  const [newUser, setNewUser] = useState({
    name: '',
    address: '',
    email: '',
    phone: '',
    notes: '',
    cars: [{ model: '', name: '', regNo: '', carFreeTime: [{ day: '', from: '', to: '' }], type: '', location: '', gps: '', notes: '' ,imageUrl: '' }],
  });
  const [loading, setLoading] = useState(false);
  
  useEffect(() => {
    if (user && user._id) {
      const token = JSON.parse(localStorage.getItem('auth_token_crm'))?.token;
      fetch(`${process.env.REACT_APP_SERVER_URI}/users/${user._id}`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: token ? `Bearer ${token}` : '',
        },
      })
        .then(res => res.json())
        .then(data => {
            setNewUser({
            name: data.name || '',
            email: data.email || '',
            address: data.address || '',
            phone: data.phone || '',
            notes: data.notes || '',
            cars: Array.isArray(data.cars) && data.cars.length > 0
              ? data.cars.map(car => ({
                ...car,
                gps: Array.isArray(car.gps) && car.gps.length === 2
                ? `https://www.google.com/maps?q=${car.gps[0]},${car.gps[1]}`
                : (car.gps || ''),
                carFreeTime:
                Array.isArray(car.carFreeTime) && car.carFreeTime.length > 0
                  ? car.carFreeTime.map(ft => ({
                    day: ft.day || '',
                    from: ft.from || '',
                    to: ft.to || ''
                  }))
                  : [{ day: '', from: '', to: '' }]
              }))
              : [{ model: '', name: '', regNo: '', carFreeTime: [{ day: '', from: '', to: '' }], type: '', location: '', gps: '', notes: '', imageUrl: '' }]
            });
        })
        .catch(() => {
          setNewUser({
            name: '',
            address: '',
            email: '',
            phone: '',
            notes: '',
            cars: [{ model: '', name: '', regNo: '', carFreeTime: [{ day: '', from: '', to: '' }], type: '', location: '', gps: '', notes: '', imageUrl: '' }],
          });
        });
    } else if (user) {
      setNewUser({
        name: user.name || '',
        email: user.email || '',
        address: user.address || '',
        phone: user.phone || '',
        notes: user.notes || '',
        cars: Array.isArray(user.cars) && user.cars.length > 0
          ? user.cars.map(car => ({
              ...car,
              carFreeTime:
                Array.isArray(car.carFreeTime) && car.carFreeTime.length > 0
                  ? car.carFreeTime.map(ft => ({
                      day: ft.day || '',
                      from: ft.from || '',
                      to: ft.to || ''
                    }))
                  : [{ day: '', from: '', to: '' }]
            }))
          : [{ model: '', name: '', regNo: '', carFreeTime: [{ day: '', from: '', to: '' }], type: '', location: '', gps: '', notes: '', imageUrl: '' }]
      });
    } else {
      setNewUser({
        name: '',
        address: '',
        email: '',
        phone: '',
        notes: '',
        cars: [{ model: '', name: '', regNo: '', carFreeTime: [{ day: '', from: '', to: '' }], type: '', location: '', gps: '', notes: '', imageUrl: '' }],
      });
    }
  }, [user, open]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setNewUser(prev => ({ ...prev, [name]: value }));
  };

  const handleCarChange = (idx, field, value) => {
    console.log(idx, field, value);
    setNewUser(prev => ({
      ...prev,
      cars: prev.cars.map((car, i) =>
        i === idx ? { ...car, [field]: value } : car
      )
    }));
  };

  const handleCarRegNoBlur = (idx, value) => {
    const formattedValue = value.toUpperCase().replace(/\s+/g, '');
    handleCarChange(idx, 'regNo', formattedValue);
  };

  const handleAddCar = () => {
    setNewUser(prev => {
      const lastCar = prev.cars[prev.cars.length - 1] || {};
      return {
        ...prev,
        cars: [
          ...prev.cars,
          {
            model: '',
            name: '',
            regNo: '',
            carFreeTime: lastCar.carFreeTime
              ? lastCar.carFreeTime.map(ft => ({
                  day: ft.day || '',
                  from: ft.from || '',
                  to: ft.to || ''
                }))
              : [{ day: '', from: '', to: '' }],
            type: lastCar.type || '',
            location: lastCar.location || '',
            gps: lastCar.gps || '',
            notes: lastCar.notes || ''
          }
        ]
      };
    });
  };

  const handleRemoveCar = (idx) => {
    setNewUser(prev => ({
      ...prev,
      cars: prev.cars.length > 1 ? prev.cars.filter((_, i) => i !== idx) : prev.cars
    }));
  };

  const handleCarFreeTimeChange = (carIdx, freeIdx, field, value) => {
    setNewUser(prev => ({
      ...prev,
      cars: prev.cars.map((car, i) =>
        i === carIdx
          ? {
              ...car,
              carFreeTime: (car.carFreeTime || []).map((ft, j) =>
                j === freeIdx ? { ...ft, [field]: value } : ft
              ),
            }
          : car
      ),
    }));
  };

  const handleAddCarFreeTime = (carIdx) => {
    setNewUser(prev => ({
      ...prev,
      cars: prev.cars.map((car, i) =>
        i === carIdx
          ? {
              ...car,
              carFreeTime: [...(car.carFreeTime || []), { day: '', from: '', to: '' }],
            }
          : car
      ),
    }));
  };

  const handleRemoveCarFreeTime = (carIdx, freeIdx) => {
    setNewUser(prev => ({
      ...prev,
      cars: prev.cars.map((car, i) =>
        i === carIdx
          ? {
              ...car,
              carFreeTime:
                (car.carFreeTime || []).length > 1
                  ? car.carFreeTime.filter((_, j) => j !== freeIdx)
                  : car.carFreeTime,
            }
          : car
      ),
    }));
  };
console.log(process.env.REACT_APP_SERVER_URI)
  const handleAddOrEdit = () => {
    setLoading(true);
    const token = JSON.parse(localStorage.getItem('auth_token_crm'))?.token;
    const url = user?._id
      ? `${process.env.REACT_APP_SERVER_URI}/users/update/${user._id}`
      : `${process.env.REACT_APP_SERVER_URI}/users/add`;
    const method = 'POST';
    // Send cars as 'cars' field in backend
    // Convert car.gps (Google map url) to [lat, long] array before sending

    fetch(url, {
      method,
      headers: {
      'Content-Type': 'application/json',
      Authorization: token ? `Bearer ${token}` : '',
      },
      body: JSON.stringify({
      name: newUser.name,
      email: newUser.email,
      phone: newUser.phone,
      address: newUser.address,
      notes: newUser.notes,
      cars: newUser.cars,
      requestId: user?.requestId || null, // Include requestId if available
      }),
    })
      .then(res => res.json())
      .then(() => {
      setLoading(false);
      setNewUser({
        name: '',
        address: '',
        email: '',
        phone: '',
        notes: '',
        cars: [{ model: '', name: '', regNo: '', carFreeTime: [{ day: '', from: '', to: '' }], type: '', location: '', gps: '', notes: '' }]
      });
      onClose();
      if (onUserAdded) onUserAdded();
      alert('User saved successfully.');
      window.location.reload();
      })
      .catch(() => {
      setLoading(false);
      alert('Failed to save user.');
      });
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>{user ? 'Edit User' : 'Add User'}</DialogTitle>
      <DialogContent>
        <TextField
          label="Name"
          name="name"
          value={newUser.name}
          onChange={handleChange}
          fullWidth
          margin="normal"
          required
        />
        <TextField
          label="Email"
          name="email"
          value={newUser.email}
          onChange={handleChange}
          fullWidth
          margin="normal"
          type="email"
        />
        <TextField
          required
          label="Phone"
          name="phone"
          value={newUser.phone}
          onChange={handleChange}
          fullWidth
          margin="normal"
        />
        <TextField
          label="Address"
          name="address"
          value={newUser.address || ''}
          onChange={handleChange}
          fullWidth
          margin="normal"
        />
        <TextField
          label="User Notes"
          name="notes"
          value={newUser.notes}
          onChange={handleChange}
          fullWidth
          margin="normal"
          multiline
          minRows={2}
        />
        <Grid container spacing={2} sx={{ mt: 1 }}>
          {newUser.cars.map((car, idx) => (
            <Grid container key={idx}>
              <Grid item xs={12} sm={2.4}>
                <TextField
                  label="Model"
                  value={car.model}
                  onChange={e => handleCarChange(idx, 'model', e.target.value)}
                  fullWidth
                  margin="normal"
                  required
                />
              </Grid>
              <Grid item xs={12} sm={2.4}>
                <TextField
                  label="Car Name"
                  value={car.name}
                  onChange={e => handleCarChange(idx, 'name', e.target.value)}
                  fullWidth
                  margin="normal"
                  required
                />
              </Grid>
              <Grid item xs={12} sm={2.4}>
                <TextField
                  label="Reg No"
                  value={car.regNo}
                  onChange={e => handleCarChange(idx, 'regNo', e.target.value)}
                  onBlur={e => handleCarRegNoBlur(idx, e.target.value)}
                  fullWidth
                  margin="normal"
                  required
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  select
                  label="Car Type"
                  sx={{
                    minWidth: 120,
                  }}
                  value={car.type || ''}
                  onChange={e => handleCarChange(idx, 'type', e.target.value)}
                  fullWidth
                  margin="normal"
                  required
                >
                  <MenuItem value="sedan">Sedan</MenuItem>
                  <MenuItem value="hatchback">Hatchback</MenuItem>
                  <MenuItem value="compact suv">Compact SUV</MenuItem>
                  <MenuItem value="suv">SUV</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={12} sm={2.4}>
                <TextField
                  sx={{
                    minWidth: 120,
                  }}
                  select
                  label="Location"
                  value={car.location || ''}
                  onChange={e => handleCarChange(idx, 'location', e.target.value)}
                  fullWidth
                  margin="normal"
                >
                  {LOCATION_OPTIONS.map(option => (
                    <MenuItem key={option} value={option}>{option}</MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} sm={2.4}>
                <TextField
                  label="Google map url"
                  value={car.gps || ''}
                  onChange={e => handleCarChange(idx, 'gps', e.target.value)}
                  fullWidth
                  margin="normal"
                />
              </Grid>
              <Grid item xs={12} sm={2.4}>
                <TextField
                  label="Color"
                  name="color"
                  value={car.color || ''}
                  onChange={e => handleCarChange(idx, 'color', e.target.value)}
                  fullWidth
                  margin="normal"
                />
              </Grid>
              <Grid item xs={12} sm={2.4}>
                <Box sx={{ mt: 2 }}>
                </Box>
              </Grid>
              <Grid item xs={12} sm={12}>
                <TextField
                  label="Car Notes"
                  value={car.notes || ''}
                  onChange={e => handleCarChange(idx, 'notes', e.target.value)}
                  fullWidth
                  margin="normal"
                  multiline
                  minRows={2}
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <UploadComp onUploadSuccess={imageUrl => handleCarChange(idx, 'imageUrl', imageUrl)} imageUrl={car.imageUrl} />
              </Grid>
              <Grid item xs={12} sm={12}>
                <Box sx={{ mb: 1 }}>
                  <strong>Car Free Time</strong>
                  {(car.carFreeTime && car.carFreeTime.length > 0
                    ? car.carFreeTime
                    : [{ day: '', from: '', to: '' }]
                  ).map((ft, freeIdx) => (
                    <Box key={freeIdx} sx={{ display: 'flex', gap: 2, alignItems: 'center', mt: 1 }}>
                      <TextField
                        select
                        label="Day"
                        value={ft.day}
                        onChange={e => handleCarFreeTimeChange(idx, freeIdx, 'day', e.target.value)}
                        size="small"
                        sx={{ minWidth: 120 }}
                      >
                        {WEEK_DAYS.map(day => (
                          <MenuItem key={day} value={day}>{day}</MenuItem>
                        ))}
                      </TextField>
                      <TextField
                        label="From"
                        type="time"
                        value={ft.from}
                        onChange={e => handleCarFreeTimeChange(idx, freeIdx, 'from', e.target.value)}
                        size="small"
                        InputLabelProps={{ shrink: true }}
                        sx={{ minWidth: 120 }}
                      />
                      <TextField
                        label="To"
                        type="time"
                        value={ft.to}
                        onChange={e => handleCarFreeTimeChange(idx, freeIdx, 'to', e.target.value)}
                        size="small"
                        InputLabelProps={{ shrink: true }}
                        sx={{ minWidth: 120 }}
                      />
                      <IconButton
                        onClick={() => handleRemoveCarFreeTime(idx, freeIdx)}
                        disabled={(car.carFreeTime || []).length === 1}
                        size="small"
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                      {freeIdx === (car.carFreeTime?.length || 1) - 1 && (
                        <IconButton
                          onClick={() => handleAddCarFreeTime(idx)}
                          size="small"
                        >
                          <AddIcon fontSize="small" />
                        </IconButton>
                      )}
                    </Box>
                  ))}
                </Box>
              </Grid>
              <Grid item xs={12} sm={0.6} sx={{ display: 'flex', alignItems: 'center', mt: 2 }}>
                <IconButton onClick={() => handleRemoveCar(idx)} disabled={newUser.cars.length === 1}>
                  <DeleteIcon />
                </IconButton>
              </Grid>
            </Grid>
          ))}
          <Grid item xs={12} sx={{ mt: 2 }}>
            <Button variant="text" onClick={handleAddCar}>
              Add Car
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>Cancel</Button>
        <Button onClick={handleAddOrEdit} variant="contained" color="primary" disabled={loading}>
          {user ? 'Update' : 'Add'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddUserDialog;
